// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fm-synth-demo {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.fm-synth-demo-controls {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 12px;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  box-sizing: border-box;

  > div {
    overflow-y: auto;
  }
}

.fm-synth-main-control-panel {
  display: flex;
  flex-direction: column;
  background-color: rgb(35, 35, 35);
  min-width: 400px;
}

@media screen and (max-width: 799px) {
  .fm-synth-main-control-panel {
    min-width: 100vw;
  }

  select,
  input,
  button {
    font-size: 10px;
  }
}

.fm-synth-mobile-links {
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

@media screen and (min-width: 800px) {
  .fm-synth-mobile-links {
    display: none;
  }
}

@media screen and (min-height: 500px) {
  .fm-synth-mobile-links {
    display: flex;
    flex-direction: column;

    > br {
      display: none;
    }
    > * {
      margin-bottom: 8px;
      font-size: 15px;
    }
  }
}

.fm-synth-filter-control-panel {
  display: flex;
  background: rgb(35, 35, 35);
  min-width: 530px;
  padding: 14px 14px 8px;
  opacity: 0.95;
  flex-basis: 700px;
  flex-direction: column;
}

.midi-keyboard-wrapper {
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: flex-end;
}

#root div.fm-synth-main-control-panel > div:nth-child(1) > div:nth-child(1) > div.draggable > span {
  color: rgb(216, 36, 36) !important;
}

#root
  > div
  > div.fm-synth-demo-controls
  > div.fm-synth-main-control-panel
  > div:nth-child(2)
  > div:nth-child(1) {
  color: white !important;
}

#simd-status {
  max-width: 200px;
  z-index: 5;
}

/* Make github corner smaller on Mobile so it doesn't cover up important UI */
@media screen and (max-width: 799px) {
  .github-corner > svg {
    transform: scale(0.5) translate(40px, -40px);
  }

  .ReactPiano__NoteLabelContainer {
    display: none;
  }

  #simd-status {
    display: none !important;
    pointer-events: none;
    line-height: 1;
  }

  #fm-synth-links {
    display: none;
  }
}

@media screen and (min-width: 1000px) {
  .midi-keyboard {
    max-width: calc(100vw - 400px);
  }
}

.fm-synth-demo-mobile-text {
  padding-left: 10px;
  padding-right: 10px;
}

@media screen and (max-height: 350px) {
  .fm-synth-demo-mobile-text {
    display: none;
  }
}

@media screen and (max-height: 420px) {
  .fm-synth-demo-mobile-text {
    font-size: 14px;
    line-height: 1.1;

    p {
      margin-top: 2px;
      margin-bottom: 2px;
    }
  }
}

@media screen and (max-height: 388px) {
  .fm-synth-demo-mobile-text {
    font-size: 12px !important;
    line-height: 1 !important;

    p {
      margin-top: 2px !important;
      margin-bottom: 2px !important;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/fmDemo/fmDemo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;;EAEtB;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,aAAa;IACf;IACA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;;EAME,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,6EAA6E;AAC7E;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;;IAEhB;MACE,eAAe;MACf,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,yBAAyB;;IAEzB;MACE,0BAA0B;MAC1B,6BAA6B;IAC/B;EACF;AACF","sourcesContent":[".fm-synth-demo {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.fm-synth-demo-controls {\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 12px;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  > div {\n    overflow-y: auto;\n  }\n}\n\n.fm-synth-main-control-panel {\n  display: flex;\n  flex-direction: column;\n  background-color: rgb(35, 35, 35);\n  min-width: 400px;\n}\n\n@media screen and (max-width: 799px) {\n  .fm-synth-main-control-panel {\n    min-width: 100vw;\n  }\n\n  select,\n  input,\n  button {\n    font-size: 10px;\n  }\n}\n\n.fm-synth-mobile-links {\n  text-align: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n@media screen and (min-width: 800px) {\n  .fm-synth-mobile-links {\n    display: none;\n  }\n}\n\n@media screen and (min-height: 500px) {\n  .fm-synth-mobile-links {\n    display: flex;\n    flex-direction: column;\n\n    > br {\n      display: none;\n    }\n    > * {\n      margin-bottom: 8px;\n      font-size: 15px;\n    }\n  }\n}\n\n.fm-synth-filter-control-panel {\n  display: flex;\n  background: rgb(35, 35, 35);\n  min-width: 530px;\n  padding: 14px 14px 8px;\n  opacity: 0.95;\n  flex-basis: 700px;\n  flex-direction: column;\n}\n\n.midi-keyboard-wrapper {\n  display: flex;\n  justify-content: center;\n  flex: 1;\n  align-items: flex-end;\n}\n\n#root div.fm-synth-main-control-panel > div:nth-child(1) > div:nth-child(1) > div.draggable > span {\n  color: rgb(216, 36, 36) !important;\n}\n\n#root\n  > div\n  > div.fm-synth-demo-controls\n  > div.fm-synth-main-control-panel\n  > div:nth-child(2)\n  > div:nth-child(1) {\n  color: white !important;\n}\n\n#simd-status {\n  max-width: 200px;\n  z-index: 5;\n}\n\n/* Make github corner smaller on Mobile so it doesn't cover up important UI */\n@media screen and (max-width: 799px) {\n  .github-corner > svg {\n    transform: scale(0.5) translate(40px, -40px);\n  }\n\n  .ReactPiano__NoteLabelContainer {\n    display: none;\n  }\n\n  #simd-status {\n    display: none !important;\n    pointer-events: none;\n    line-height: 1;\n  }\n\n  #fm-synth-links {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 1000px) {\n  .midi-keyboard {\n    max-width: calc(100vw - 400px);\n  }\n}\n\n.fm-synth-demo-mobile-text {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n@media screen and (max-height: 350px) {\n  .fm-synth-demo-mobile-text {\n    display: none;\n  }\n}\n\n@media screen and (max-height: 420px) {\n  .fm-synth-demo-mobile-text {\n    font-size: 14px;\n    line-height: 1.1;\n\n    p {\n      margin-top: 2px;\n      margin-bottom: 2px;\n    }\n  }\n}\n\n@media screen and (max-height: 388px) {\n  .fm-synth-demo-mobile-text {\n    font-size: 12px !important;\n    line-height: 1 !important;\n\n    p {\n      margin-top: 2px !important;\n      margin-bottom: 2px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
